<template >
  <v-main class="map-content">   
  <v-container grid-list-xl fluid style="height: auto;">
     <v-layout row wrap fluid style="padding-block: 0px; margin-top: 40px;">
        <v-flex xs12 sm12 md12 lg12 xl12>
  <div class="d-flex-row">
    <form class="formInput" @submit.prevent="addMarker">
<gmap-autocomplete class="input" @place_changed="setPlace"></gmap-autocomplete>
      <v-btn outlined type="submit" @click="addMarker" color="#b9acec" style="border-radius: 20px; font-color: #fff; margin-left:20px; height: 35px">Find</v-btn>
      <!-- <v-btn outlined @click="getBusinessData" color="success" style="font-color: #fff; margin-left:20px">Business Data</v-btn>
  <v-btn outlined @click="shareLocation" color="#fff" style="font-color: #ffffff; margin-left:20px">Share</v-btn>
  <v-btn outlined @click="findDirections" color="warning" style="font-color: #fff; margin-left:20px">Directions</v-btn> -->
  <v-btn outlined @click="toggleStreetView" color="#fff" style="border-radius: 20px; font-color: #fff; margin-left:20px; height: 35px">Street</v-btn>
</form>
  </div>
  <div>
  <!-- Google map : {{this.mapCoordinates}} -->
  <gmap-map
    :center="{lat: this.coords.lat,lng:this.coords.lng }" :zoom="this.zoom" zoomControl: true  map-type-id="terrain"
    class="map"
    ref="mapRef"
  >
    <gmap-marker
      :key="index"
      v-for="(m, index) in markers"
      :position="m.position"
      @click="center=m.position"
    ></gmap-marker>
  </gmap-map>
</div>
</v-flex>
</v-layout>
</v-container>
</v-main>
</template>


<script>
import startAudio from '@/assets/audio/zoom4.wav';
import startAudio2 from '@/assets/audio/mapsearch.wav';
import startAudio3 from '@/assets/audio/complete2.wav';
import {gmapApi} from 'vue2-google-maps';
export default {
name: "Map",
components: {
},
data: () => ({
  mapGoogle: ``,
  locationDetails: {},
  coords: {
    lat: 0,
    lng: 0,
  },
  zoom: 3,
  map: null,
  google:gmapApi,
  markers: [],
  places: [],
  nightModeStyles: [
  { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
  { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
    {
      featureType: "administrative.locality",
      elementType: "labels.text.fill",
      stylers: [{ color: "#d59563" }],
    },
    {
      featureType: "poi",
      elementType: "labels.text.fill",
      stylers: [{ color: "#d59563" }],
    },
    {
      featureType: "poi.park",
      elementType: "geometry",
      stylers: [{ color: "#263c3f" }],
    },
    {
      featureType: "poi.park",
      elementType: "labels.text.fill",
      stylers: [{ color: "#6b9a76" }],
    },
    {
      featureType: "road",
      elementType: "geometry",
      stylers: [{ color: "#38414e" }],
    },
    {
      featureType: "road",
      elementType: "geometry.stroke",
      stylers: [{ color: "#212a37" }],
    },
    {
      featureType: "road",
      elementType: "labels.text.fill",
      stylers: [{ color: "#9ca5b3" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry",
      stylers: [{ color: "#746855" }],
    },
    {
      featureType: "road.highway",
      elementType: "geometry.stroke",
      stylers: [{ color: "#1f2835" }],
    },
    {
      featureType: "road.highway",
      elementType: "labels.text.fill",
      stylers: [{ color: "#f3d19c" }],
    },
    {
      featureType: "transit",
      elementType: "geometry",
      stylers: [{ color: "#2f3948" }],
    },
    {
      featureType: "transit.station",
      elementType: "labels.text.fill",
      stylers: [{ color: "#d59563" }],
    },
    {
      featureType: "water",
      elementType: "geometry",
      stylers: [{ color: "#17263c" }],
    },
    {
      featureType: "water",
      elementType: "labels.text.fill",
      stylers: [{ color: "#515c6d" }],
    },
    {
      featureType: "water",
      elementType: "labels.text.stroke",
      stylers: [{ color: "#17263c" }],
    },
  ],
  currentPlace: null,
  directionsDisplay:null

}),
methods: {
  readOutLoud: (msg) => {
    const speech = new SpeechSynthesisUtterance();
    const voiceName = 'Google UK English Male';
    speech.volume = 1;
    speech.rate = 1;
    speech.pitch = 1;
    speech.voice = speechSynthesis.getVoices().filter(function (voice) {
    return voice.name === voiceName
  })[0]
    speech.text = msg;
    window.speechSynthesis.speak(speech);
  },
  setPlace(place) {
    this.currentPlace = place;
    setTimeout(() => {
      const audio = new Audio(startAudio2);
      audio.volume = 0.2; // Set the volume to 50% (value between 0 and 1)
      audio.play();
      }, 100);
  },
  
  addMarker() {
    if (this.currentPlace) {
      console.log(this.currentPlace.geometry.location);
      const marker = {
        lat: this.currentPlace.geometry.location.lat(),
        lng: this.currentPlace.geometry.location.lng(),
      };
      this.coords = marker;
       this.markers=[]
      this.markers.push({ position: marker });
      let zoomLevel = this.zoom;
    const zoomInterval = setInterval(() => {
      if (zoomLevel < 18) {
        zoomLevel += 0.12;
        this.zoom = zoomLevel;
      } else {
        clearInterval(zoomInterval);
        this.map.setMapTypeId('satellite'); // Change to satellite mode
      }
    }, 5);
      this.places.push(this.currentPlace);
      this.center = marker;
      this.currentPlace = null;
      this.getRoute();
    }
  },
  toggleStreetView() {
    const panorama = this.map.getStreetView();
    panorama.setPosition(this.currentPlace.geometry.location);
    panorama.setPov({ heading: 34, pitch: 10 });
    panorama.setVisible(!panorama.getVisible());
  },
  getBusinessData() {
    if (this.currentPlace) {
      const place = this.currentPlace;
      const request = {
        placeId: place.place_id,
        fields: [
          "name",
          "rating",
          "formatted_phone_number",
          "geometry",
          "formatted_address",
          "website",
          "opening_hours",
          "photos",
        ],
      };
      const service = new this.google.maps.places.PlacesService(
        this.$refs.mapRef.$mapObject
      );
      service.getDetails(request, (place, status) => {
        if (status === this.google.maps.places.PlacesServiceStatus.OK) {
          console.log(place);
          this.locationDetails = place;
          this.$emit("location-details", place);
        }
      });
    }
  },
  shareLocation() {
    if (this.currentPlace) {
      const place = this.currentPlace;
      const request = {
        placeId: place.place_id,
        fields: [
          "name",
          "rating",
          "formatted_phone_number",
          "geometry",
          "formatted_address",
          "website",
          "opening_hours",
          "photos",
        ],
      };
      const service = new this.google.maps.places.PlacesService(
        this.$refs.mapRef.$mapObject
      );
      service.getDetails(request, (place, status) => {
        if (status === this.google.maps.places.PlacesServiceStatus.OK) {
          console.log(place);
          this.locationDetails = place;
          this.$emit("location-details", place);
        }
      });
    }
  },
  findDirections() {
    if (this.currentPlace) {
      const place = this.currentPlace;
      const request = {
        placeId: place.place_id,
        fields: [
          "name",
          "rating",
          "formatted_phone_number",
          "geometry",
          "formatted_address",
          "website",
          "opening_hours",
          "photos",
        ],
      };
      const service = new this.google.maps.places.PlacesService(
        this.$refs.mapRef.$mapObject
      );
      service.getDetails(request, (place, status) => {
        if (status === this.google.maps.places.PlacesServiceStatus.OK) {
          console.log(place);
          this.locationDetails = place;
          this.$emit("location-details", place);
        }
      });
    }
  },
  addSmoothing() {
    this.google.maps.Polyline({
      path: this.directionsDisplay.getDirections().routes[0].overview_path,
      strokeOpacity: 0.5,
      strokeWeight: 4,
      map: this.$refs.mapRef.$mapObject,
      smoothPolyline: true,
    });
  },
  getRoute: function (destination) {
    this.directionsService = new window.google.maps.DirectionsService()
    this.directionsDisplay = new window.google.maps.DirectionsRenderer()
    this.directionsDisplay.setMap(this.$refs.mapRef.$mapObject)
    var vm = this
    let zoomLevel = this.zoom;
    setTimeout(() => {
    const audio = new Audio(startAudio);
audio.volume = 0.2; // Set the volume to 50% (value between 0 and 1)
audio.play();
}, 500);
setTimeout(() => {
const audio = new Audio(startAudio3);
audio.volume = 0.25; // Set the volume to 50% (value between 0 and 1)
audio.play();
}, 5000);
    const zoomInterval = setInterval(() => {
      if (zoomLevel < 18) {
        zoomLevel += 0.12;
        this.zoom = zoomLevel;
      } else {
        clearInterval(zoomInterval);
        this.map.setMapTypeId('satellite'); // Change to satellite mode
      }
    }, 5);
    vm.directionsService.route({
      origin: this.coords,
      destination:  destination,
      travelMode: 'DRIVING'
    }, function (response, status) {
      if (status === 'OK') {
        vm.directionsDisplay.setDirections(response);
        vm.addMarker()
      } else {
        console.log('Directions request failed due to ' + status)
      }
    })
  },
  getDirections: function (destination) {
    this.directionsService = new window.google.maps.DirectionsService()
    this.directionsDisplay = new window.google.maps.DirectionsRenderer()
    this.directionsDisplay.setMap(this.$refs.mapRef.$mapObject)
    var vm = this
    let zoomLevel = this.zoom;
    setTimeout(() => {
    const audio = new Audio(startAudio);
audio.volume = 0.2; // Set the volume to 50% (value between 0 and 1)
audio.play();
}, 500);
setTimeout(() => {
const audio = new Audio(startAudio3);
audio.volume = 0.25; // Set the volume to 50% (value between 0 and 1)
audio.play();
}, 5000);
    const zoomInterval = setInterval(() => {
      if (zoomLevel < this.addMarker) {
        zoomLevel += 0.12;
        this.zoom = zoomLevel;
      } else {
        clearInterval(zoomInterval);
        this.map.setMapTypeId('satellite'); // Change to satellite mode
      }
    }, 5);
    vm.directionsService.route({
      origin: this.coords,
      destination:  destination,
      travelMode: 'DRIVING'
    }, function (response, status) {
      if (status === 'OK') {
        vm.directionsDisplay.setDirections(response);
        vm.addMarker()
      } else {
        console.log('Directions request failed due to ' + status)
      }
    })
  }
},
mounted() {
  this.$refs.mapRef.$mapPromise.then((map) => {
  this.map = map;
  map.setOptions({ styles: this.nightModeStyles }); // Apply the night mode styles
});
  this.$refs.mapRef.$mapPromise.then((map) => (this.map = map));
      Event.$on("show my location", (data) => {
        data= data.msg.slice(7)
        if(!data) return;
        this.getRoute(data);
      // return; 
  });
  Event.$on("directions to", (data) => {
    data= data.msg.slice(7)
    if(!data) return;
    this.getDirections(data);
  // return;
  });
  // Event.$on("speakModeOn", () => {
  //   console.log("Speak Mode On");
  //   const msg = new SpeechSynthesisUtterance("Speak Mode On");
  //   window.speechSynthesis.speak(msg);
  // });
      // Print and readOutLoud
  Event.$on("location-found", () => {
    console.log("Location Found. Would you like to find the business data, share it, or find directions from your location to this address?");
    const msg = new SpeechSynthesisUtterance("Location Found. Would you like to find the business data, share it, or find directions from your location to this address?");
    window.speechSynthesis.speak(msg);
  });
},
created() {
  // this.getWeather();
  this.$getLocation({}).then((coords) => {
    this.coords = coords;
    this.markers.push({ position: coords });
    console.log(this.coords);
  });
},
computed: {
  mapCoordinates() {
    if (!this.map) {
      return {
        lat: 0,
        lng: 0,
      };
    }

    return {
      lat: this.map.getCenter().lat(),
      lng: this.map.getCenter().lng(),
    };
  },
},
};
</script>

<style scoped>

.input{
  color: primary; 
  max-width: 100%; 
  padding: 6px; 
  margin-top: -10px; 
  margin-left: 50px; 
  z-index: 1;
  width: 300px;
  border-radius: 20px;
  color: rgb(61, 157, 61);
}
@media only screen and (max-width: 600px) {
.input{
  color: primary; 
  width: 170px; 
  padding: 6px; 
  margin-top: 50px;
  padding-top: 20px;
  padding-bottom: 5px; 
  margin-left: 20px; 
  z-index: 1;
}
}
.map{
  max-width: 101%;
  min-width: 101%; 
  height: 84vh;
  left: -10px; 
  top: -80px;
  margin-block: -10px; 
  z-index: 0; 
  overflow: hidden; 
}

.smooth-animation {
  transition: opacity 2s, transform 2s;
}
.map-content {
  background: #131f25e7;
  padding: 0px;
  height: 86vh;
  min-width: 100%;
  align-items: center;
  -webkit-animation: gradient 25s ease infinite;
  -animation: gradient 25s ease infinite;
}
@media only screen and (max-width: 600px) {
.map-content {
  background: #131f25e7;
  padding: 0px;
  min-height: 100vh;
  margin-bottom: 0px;
}
}
.d-flex-row{
display: flex;
flex-direction: row;
justify-content: center;
}
.chart-content {
background: rgba(12, 22, 27, 0);
animation: glow 1800ms ease-out infinite alternate;
color: #efe;
outline-width: 2px;
padding: 0px;
border-radius: 10px;
margin: 0px;
animation: cardAnimate 1s ease-in-out;
align-content: center;
align-items: center;
align-self: center;
justify-content: center;
justify-items: center;
justify-self: center;
margin: 0 auto;
max-width: 100%;
min-width: 100%;
width: 100%;
height: 100%;
}

@-webkit-keyframes gradient {
0% {
  background-position: 0% 50%;
}
50% {
  background-position: 100% 50%;
}
100% {
  background-position: 0% 50%;
}
}

@keyframes gradient {
0% {
  background-position: 0% 50%;
}
50% {
  background-position: 100% 50%;
}
100% {
  background-position: 0% 50%;
}
height: 150%;
}


@media only screen and (max-width: 600px) {
.chart-content {
background: rgba(12, 22, 27, 0.4);
animation: glow 1800ms ease-out infinite alternate;
color: #efe;
outline-width: 2px;
padding: 25px;
border-radius: 10px;
max-width: 1800px;
margin: 0px;
}

@-webkit-keyframes gradient {
0% {
  background-position: 0% 50%;
}
50% {
  background-position: 100% 50%;
}
100% {
  background-position: 0% 50%;
}
}

@keyframes gradient {
0% {
  background-position: 0% 50%;
}
50% {
  background-position: 100% 50%;
}
100% {
  background-position: 0% 50%;
}
height: 150%;
}

}

.formInput{
  color: primary; 
  max-width: 100%; 
  padding: 20px; 
  margin-top: -50px; 
  margin-left:30px; 
  z-index: 1;
  
}
@media only screen and (max-width: 600px) {
.formInput{
  color: primary; 
  min-width: 400px; 
  padding: 0px; 
  margin-top: -50px;
  padding-bottom: 20px; 
  margin-left: -0px; 
  z-index: 1;
}
}
.formInput2{
  color: primary; 
  max-width: 100%; 
  padding: 30px; 
  margin-top: -15px; 
  margin-left:40px; 
  z-index: 1;
  
}
@media only screen and (max-width: 600px) { 
  color: primary; 
  min-width: 380px; 
  padding: 0px; 
  margin-top: -5px;
  padding-bottom: 60px; 
  margin-left: 50px; 
  z-index: 1;
}

.map-container{
padding: 20px;
}
.button {
  background-color: #4CAF50; /* Green */
  border: none;
  color: white;
  padding: 10px 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  border-radius: 20px; 
  margin-left:20px; 
  height: 35px
}
</style>